export default {
    dashboards: (state) => state.dashboards,
    isLoadedDashboards: (state) => state.isLoadedDashboards,
    userDashboards: (state) => state.userDashboards,
    isLoadedUserDashboards: (state) => state.isLoadedUserDashboards,
    gameTypes: (state) => state.gameTypes,
    isLoadedGameTypes: (state) => state.isLoadedGameTypes,
    userGameTypes: (state) => state.userGameTypes,
    isLoadedUserGameTypes: (state) => state.isLoadedUserGameTypes,
};
